"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attributionApiClient = void 0;
const data_lib_1 = require("@redbox-ruby/data-lib");
function attributionApiClient(networkClient) {
    return {
        listAttributionEvents: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.ATTRIBUTION_WEB_SERVICE, `/api/v2/attribution/teams/${params.teamId}/events`, query, config);
        },
        countEvents: async (params, query) => {
            return networkClient.getHttp(data_lib_1.ATTRIBUTION_WEB_SERVICE, `/api/v2/attribution/teams/${params.teamId}/events/counts`, query);
        },
        summariseEvents: async (params, query) => {
            return networkClient.getHttp(data_lib_1.ATTRIBUTION_WEB_SERVICE, `/api/v2/attribution/teams/${params.teamId}/events/summary`, query);
        },
        groupEvents: async (params, query) => {
            return networkClient.getHttp(data_lib_1.ATTRIBUTION_WEB_SERVICE, `/api/v2/attribution/teams/${params.teamId}/campaigns/reports/grouping`, query);
        },
        summariseFlows: async (params, query) => {
            return networkClient.getHttp(data_lib_1.ATTRIBUTION_WEB_SERVICE, `/api/v2/attribution/teams/${params.teamId}/flows`, query);
        },
        generateAttributionSecretKey: async (body) => {
            return networkClient.postHttp(data_lib_1.ATTRIBUTION_WEB_SERVICE, "/api/v2/attribution/keys", body);
        },
        createRedboxAttributionEvent: async (event) => {
            return networkClient.postHttp(data_lib_1.ATTRIBUTION_ENDPOINT_WEB_SERVICE, "/api/v2/attribution-endpoint/redbox/events", event);
        },
        createAppsFlyerAttributionEvent: async (event) => {
            return networkClient.getHttp(data_lib_1.ATTRIBUTION_ENDPOINT_WEB_SERVICE, "/api/v2/attribution-endpoint/appsflyer/events", event);
        },
        createAdjustAttributionEvent: async (event) => {
            return networkClient.getHttp(data_lib_1.ATTRIBUTION_ENDPOINT_WEB_SERVICE, "/api/v2/attribution-endpoint/adjust/events", event);
        },
        createBranchAttributionEvent: async (event) => {
            return networkClient.getHttp(data_lib_1.ATTRIBUTION_ENDPOINT_WEB_SERVICE, "/api/v2/attribution-endpoint/branch/events", event);
        },
    };
}
exports.attributionApiClient = attributionApiClient;
